module.exports = __webpack_public_path__ + "static/media/loader.d542c686.svg";